import type {
  NotificationsResponse,
  GetNotificationsParams,
  MarkAsReadResponse,
  MarkAllAsReadResponse,
} from '../model/types'
import { useApi } from '@shared/api'

/**
 * API-клиент уведомлений пользователя.
 * Базовый URL: /api/v2/user/notifications
 */
class APINotification {
  /**
   * Получить список уведомлений пользователя.
   * GET /api/v2/user/notifications
   */
  async getNotifications(params: GetNotificationsParams = {}): Promise<NotificationsResponse> {
    const { limit = 10, offset = 0, unreadOnly } = params

    const response = await useApi(true).get('/user/notifications', {
      params: {
        limit,
        offset,
        ...(unreadOnly !== undefined && { unreadOnly }),
      },
    })

    const d = response.data

    return {
      stats: {
        total: Number(d.stats.total),
        unread: Number(d.stats.unread),
        read: Number(d.stats.read),
      },
      notifications: d.notifications.map((item: any) => ({
        id: String(item.id),
        notificationId: item.notificationId,
        title: item.title,
        body: item.body,
        data: item.data ?? {},
        status: item.status,
        isRead: Boolean(item.isRead),
        sentAt: item.sentAt,
        deliveredAt: item.deliveredAt ?? null,
        openedAt: item.openedAt ?? null,
        createdAt: item.createdAt,
      })),
      total: Number(d.total),
      limit: Number(d.limit),
      offset: Number(d.offset),
    }
  }

  /**
   * Пометить уведомление как прочитанное.
   * PATCH /api/v2/user/notifications/{id}/read
   */
  async markAsRead(notificationId: string): Promise<MarkAsReadResponse> {
    const response = await useApi(true).patch(`/user/notifications/${notificationId}/read`)
    return {
      success: Boolean(response.data.success),
      message: response.data.message,
      notificationId: response.data.notificationId,
    }
  }

  /**
   * Пометить все уведомления как прочитанные.
   * POST /api/v2/user/notifications/mark-all-read
   */
  async markAllAsRead(): Promise<MarkAllAsReadResponse> {
    const response = await useApi(true).post('/user/notifications/mark-all-read')
    return {
      success: Boolean(response.data.success),
      message: response.data.message,
      markedCount: Number(response.data.markedCount),
    }
  }
}

export const apiNotification = new APINotification()
export default apiNotification
